import TransferPackageMessageModal from './TransferPackageMessageModal';

export default TransferPackageMessageModal;
